import React, { Suspense, memo } from "react";

export const DefaultSuspense = memo(({ children }: { children: React.ReactNode }) => {
  return <Suspense fallback={<div>منتظر باشید...</div>}>{children}</Suspense>;
});
